<template>
  <StaticInfo
    :name="$t('orderDetail.status')"
    :value="translatedStatus"
    :valueClass="[`status__${status}`, isInvoiced ? 'invoiced' : '']"
    data-testid="order-form__status-info"
  />
</template>

<script>
import StaticInfo from '@/components/Form/StaticInfo/index.vue'
import stringUtils from '@/components/mixins/stringUtils'

import { i18n } from '@/i18n'

export default {
  name: 'StatusInfo',
  components: { StaticInfo },
  props: {
    status: { type: String, required: true },
    isInvoiced: { type: Boolean, required: false },
  },
  computed: {
    translatedStatus() {
      if (this.isInvoiced) return i18n.t('orders.statusInvoiced')
      return i18n.t(`orders.status${this.capitalize(this.status)}`)
    },
  },
  mixins: [stringUtils],
}
</script>

<style lang="scss">
.status {
  &__open {
    background-color: var(--status-open-color);
    color: #fff;
  }
  &__assigned {
    background-color: var(--status-assigned-color);
  }
  &__closed {
    background-color: var(--status-closed-color);
    color: #fff;
    &.invoiced {
      background-color: var(--status-invoiced-color);
      color: #fff;
    }
  }
  &__done {
    background-color: var(--status-done-color);
    color: #fff;
  }
}
</style>
